import React from 'react';

import { generatePath, useNavigate } from 'react-router-dom';

import routes from '@/common/routes/index.js';
import { useUserStore } from '@/stores/userStore.js';
import { TabsNavigation } from '@/elements/TabsNavigation/index.jsx';
import { queryParamsInitial, tabPaths } from '@/common/pages/networkProtectionV2/store/index.js';

export const SubNavigation = () => {
  const user = useUserStore((state) => state);
  const navigate = useNavigate();
  const onTabChange = (value) => {
    navigate(generatePath(tabPaths[value]), { replace: true });
  };

  const list = [
    {
      title: 'Monitoring objects',
      path: generatePath(routes.netProtectionV2Monitoring),
      tab: 'monitoring-objects',
      replace: true,
    },
    {
      title: 'Protected profiles',
      tab: 'protected-profiles',
      path: generatePath(routes.netProtectionV2Protected),
      replace: true,
    },
  ];

  const selectedTab = location.pathname.includes('/protected-profiles')
    ? 'protected-profiles'
    : location.pathname.includes('/monitoring-objects')
      ? 'monitoring-objects'
      : queryParamsInitial.activeTab;

  return (
    <TabsNavigation selectedTab={selectedTab} setTab={onTabChange} tabs={list} role={user.role} />
  );
};
